import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class FeatureGroupTypeService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('feature-groups', service);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/services/feature-group-type/feature-group-type.service.ts